import React from 'react';

import { flagStyles } from '../settings';

const SvgNO = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3960px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgNO;
